import React from 'react'
import { Typography } from 'react-components'
import { useTranslation } from '../../../hooks/locale'
import { SECTION_IDS } from '../constants'

const PriceCalculatorLink = () => {
    const { t } = useTranslation()
    return (
        <span
            onClick={() => {
                const element = document.getElementById(SECTION_IDS.PRICE_SECTION_ID)
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'center' })
                }
            }}
        >
            <Typography variant="subtitle2" fontWeight="bold" element="span" textDecoration="underline">
                {t('price.calculator')}
            </Typography>
        </span>
    )
}

export default PriceCalculatorLink
